import React from 'react'
import Icon from '../../../util/Icon'
import classnames from 'classnames'

const WelcomeAction = ({ label, icon, description, active, complete, children }) => (
  <div className={classnames('welcome-action', { active, complete })}>
    <Icon icon={complete ? 'check' : icon} className="fa-fw" />
    <div>
      <div className="label">{label}</div>
      <div className="description">{description}</div>
    </div>
    <div className="actions">
      {children}
    </div>
  </div>
)

export default WelcomeAction



// WEBPACK FOOTER //
// client/components/sections/website/Welcome/action.js